<template>

	<div id="app" class="is-relative">
		<tier-selector product="compare"></tier-selector>
		<tier-selector product="backup" :minimumUsers="100"></tier-selector>
		<tier-selector product="automation" :productAvailable="isAutomationEnabled"></tier-selector>
		<tier-selector product="flowErrorMonitoring" :minimumUsers="100"></tier-selector>
		<tier-selector product="codeReviews"></tier-selector>
		<addon-selector product="addons" :productAvailable="isAddonsEnabled"></addon-selector>

		<package></package>
		<total></total>
	</div>

</template>

<script>

import Tier from './selectors/Tier.vue';
import Addon from './selectors/Addon.vue';

import Package from './summary/Package.vue';
import Total from './summary/Total.vue';

export default {
	name: 'calculator',

	computed: {
		selection() {
			return this.$store.selection || {};
		},

		/* Whether automation tiers can be selected */
		isAutomationEnabled() {
			return this.selection.compare.tier !== '' && this.selection.compare.users > 0;
		},

		/* Whether addons can be selected */
		isAddonsEnabled() {
			return {
				cpq: this.selection.compare.tier !== '' && this.selection.compare.users > 0,
				vlocity: this.selection.compare.tier !== '' && this.selection.compare.users > 0,
				sandbox: (this.selection.compare.tier !== '' && this.selection.compare.users > 0) || (this.selection.backup.tier !== '' && this.selection.backup.users > 0),
				archiving: this.selection.backup.tier !== '' && this.selection.backup.users > 0,
			};
		},
	},

	components: {
		tierSelector: Tier,
		addonSelector: Addon,
		package: Package,
		total: Total,
	},
};

</script>
